import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createClient } from '@supabase/supabase-js';
import { plannerUrl, readConfig } from './lib/config';
import { startTheme } from './lib/theme';
import { startVersionCheck } from './lib/version-check';
import { App } from './App';
import './styles.css';

// The page settles day or night before its first paint; this is the same
// decision, for any entry that reached the app another way.
startTheme();
startVersionCheck();

const root = createRoot(document.getElementById('root')!);
const result = readConfig(import.meta.env);

if (!result.ok) {
  root.render(
    <main className="centered">
      <h1>Brunel Command is not configured</h1>
      <ul>{result.problems.map((p) => <li key={p}>{p}</li>)}</ul>
    </main>,
  );
} else {
  const client = createClient(result.config.supabaseUrl, result.config.publishableKey, {
    auth: { flowType: 'pkce', persistSession: true, detectSessionInUrl: true },
  });
  // OAuth and recovery return to the origin the browser is actually running on.
  // This prevents a stale deployment variable from sending production auth to an
  // old domain or local development URL.
  const runtimeAuthRedirectUrl = window.location.pathname === '/oauth/consent'
    ? new URL(`${window.location.pathname}${window.location.search}`, window.location.origin).toString()
    : new URL('/', window.location.origin).toString();
  root.render(
    <StrictMode>
      <App client={client} redirectTo={runtimeAuthRedirectUrl} nodeConnection={{ url: result.config.supabaseUrl, publishableKey: result.config.publishableKey }}
        plannerUrl={plannerUrl(result.config.supabaseUrl)} />
    </StrictMode>,
  );
}
